import { isEmptyArray } from '../../../../utils/array-utils';
import { logger } from '../../../../utils/logger';
import { compareMonetaryValue } from '../../../../utils/monetary-value-utils';
import { isSubscriptionBillingOptionPriceAvailable } from './subscription-billing-option-price-utils';
export const getLowestSubscriptionBillingOptionPrice = (optionPrices) => {
    const availableOptionPrices = optionPrices.filter(price => isSubscriptionBillingOptionPriceAvailable(price));
    if (isEmptyArray(availableOptionPrices)) {
        logger.error('No subscription billing option prices are available');
        return;
    }
    const lowestPrice = availableOptionPrices.sort((a, b) => compareMonetaryValue(a.price, b.price))[0];
    return lowestPrice;
};
//# sourceMappingURL=get-lowest-subscription-billing-option-price.js.map